module.exports = __webpack_public_path__ + "img/Newbie_Staff_02_Classic.2208c87b.png";